import { getTranslation } from '../providers/TranslationProvider';

const getNumOfVenuesContent = (num) => {
  if (num === 0) {
    return (
      getTranslation({
        translationKey: 'lists.no_venues',
        translationValues: { num },
        fallback: `${num} venues`,
      })
    );
  }

  if (num === 1) {
    return (
      getTranslation({
        translationKey: 'lists.one_venue',
        translationValues: { num },
        fallback: `${num} venue`,
      })
    );
  }

  return (
    getTranslation({
      translationKey: 'lists.num_of_venues',
      translationValues: { num },
      fallback: `${num} venues`,
    })
  );
};

export default getNumOfVenuesContent;
